module.exports = __webpack_public_path__ + "static/media/jake-whitesell-homepage-reduced.d150559b.jpg";